<div>
  <cdx-svg-icon name="cutlery" fill="green" display="inline" size="default"></cdx-svg-icon>

  <ng-container *ngIf="preferences.adult">
    {{ preferences.adult }} {{ preferences.adult === 1 ? 'Adult' : 'Adults' }}
  </ng-container>
  <ng-container *ngIf="preferences.adult && preferences.child">, </ng-container>
  <ng-container *ngIf="preferences.child">
    {{ preferences.child }} {{ preferences.child === 1 ? 'Child' : 'Children' }} 
  </ng-container>

  <span></span>

  <div class="dietary">
    {{ preferences.dietary }}
  </div>

  <div class="dietary-future">
    Dietary <cdx-icon-circle background="dark" size="extra-small"><p>{{ preferences.dietary.length }}</p></cdx-icon-circle>
  </div>

  <span></span>
  
  <button cdxButton fillStyle="link" type="button" (click)="handleModifyButtonClick()" data-cy="modifyButton">Modify</button>

  <button (click)="handleModifyButtonClick()" type="button" aria-label="Modify" class="icon-button" data-cy="modifyIconButton">
    <cdx-icon-circle name="cutlery" background="green" fill="light" display="inline" size="default"></cdx-icon-circle>
  </button>
</div>